/**
 * ForYou.js
 *
 * Valentine's Day Special for Khushi 💌
 * -------------------------------------------------------------
 * Controller screen that toggles between:
 * 1) Question view (Yes/No with playful scaling behavior)
 * 2) Letter view (cute letter + bouquet)
 *
 * State rules:
 * - "Yes" navigates to the letter view.
 * - "No" shrinks itself and grows "Yes" until "Yes" is clicked.
 */

import React, { useMemo, useState } from "react";

import ForYouQuestionView from "./components/ForYouQuestionView";
import ForYouLetterView   from "./components/ForYouLetterView";
import ForYouStyles       from "./components/ForYouStyles";
import { useClientAuth } from "../../hooks/clientAuth";

export default function ForYou()
{
    const [step, setStep]         = useState("QUESTION"); // "QUESTION" | "LETTER"
    const [yesScale, setYesScale] = useState(1);
    const [noScale, setNoScale]   = useState(1);
    const [noClicks, setNoClicks] = useState(0);
    const { user } = useClientAuth();

    const yesDisabled = useMemo(() =>
    {
        // Keep it always clickable. This is here for future flexibility.
        return false;
    }, []);

    /**
     * handleYes
     * Switches to the letter view.
     */
    function handleYes()
    {
        setStep("LETTER");
    }

    /**
     * handleNo
     * Shrinks "No" button and grows "Yes" button progressively.
     */
    function handleNo()
    {
        setNoClicks((prev) => prev + 1);

        // Limits are set for layout stability.
        setYesScale((prev) => Math.min(prev + 0.18, 2.35));
        setNoScale((prev)  => Math.max(prev - 0.14, 0.30));
    }

    /**
     * handleReset
     * Returns to the question view and resets scaling state.
     */
    function handleReset()
    {
        setStep("QUESTION");
        setYesScale(1);
        setNoScale(1);
        setNoClicks(0);
    }

    if (!(user?.email === "khushigupta.19032001@gmail.com" || user?.email === "yash301020@gmail.com")) {
        return (
            <div className="min-h-screen items-center justify-center flex text-4xl font-bold">
                NOT FOR YOU!
            </div>
        )
    }

    return (
        <div className="min-h-screen w-full flex items-center justify-center bg-gradient-to-b from-peach via-pink to-red px-4 py-10">
            <ForYouStyles />

            <div className="w-full flex items-center justify-center">
                {step === "QUESTION" ? (
                    <ForYouQuestionView
                        yesScale={yesScale}
                        noScale={noScale}
                        noClicks={noClicks}
                        yesDisabled={yesDisabled}
                        onYes={handleYes}
                        onNo={handleNo}
                    />
                ) : (
                    <ForYouLetterView onBack={handleReset} />
                )}
            </div>
        </div>
    );
}